/**
 * PDP: School Zone + Centre Name as line item properties (cart + order admin).
 */
(function () {
  const SZ = window.ElinSchoolZone;
  if (!SZ) return;

  function init(root) {
    if (!root || root.dataset.elinProductSchoolZoneInit === '1') return;
    root.dataset.elinProductSchoolZoneInit = '1';

    const formId = root.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : null;
    const selectZone = root.querySelector('[data-elin-school-zone]');
    const selectCentre = root.querySelector('[data-elin-centre-name]');
    const errorEl = root.querySelector('[data-elin-product-school-zone-error]');
    const productForm = form.closest('product-form');

    if (!selectZone || !selectCentre || !form) return;

    SZ.ZONES.forEach(function (z) {
      const opt = document.createElement('option');
      opt.value = z;
      opt.textContent = z;
      selectZone.appendChild(opt);
    });

    SZ.fillCentreOptions(selectCentre, null, '');

    selectZone.addEventListener('change', function () {
      SZ.fillCentreOptions(selectCentre, selectZone.value, '');
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    });

    selectCentre.addEventListener('change', function () {
      if (errorEl) {
        errorEl.textContent = '';
        errorEl.hidden = true;
      }
    });

    form.addEventListener(
      'submit',
      function (e) {
        const sub = e.submitter;
        if (!sub || sub.getAttribute('name') !== 'add') return;

        const z = selectZone.value;
        const c = selectCentre.value;
        if (z && c) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        const msg =
          (window.elinProductSchoolZoneStrings && window.elinProductSchoolZoneStrings.required) ||
          'Please select School Zone and Centre Name before adding to cart.';

        if (errorEl) {
          errorEl.textContent = msg;
          errorEl.hidden = false;
        }

        if (productForm && typeof productForm.handleErrorMessage === 'function') {
          productForm.handleErrorMessage(msg);
        }

        if (!z) {
          selectZone.focus();
        } else {
          selectCentre.focus();
        }
      },
      true
    );
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-elin-product-school-zone-root]').forEach(init);
  });
})();
